export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";